import { motion } from "framer-motion";

const sparkleVariants = {
  initial: { scale: 0, opacity: 0 },
  animate: (delay: number) => ({
    scale: 1,
    opacity: 1,
    transition: { delay, duration: 0.35, ease: "easeOut" },
  }),
};

export default function PaymentSuccessIcon() {
  return (
    <motion.div
      className="relative mx-auto h-[104px] w-[104px]"
      initial={{ scale: 0.92, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
      aria-hidden="true"
    >
      <motion.span
        custom={0.15}
        variants={sparkleVariants}
        initial="initial"
        animate="animate"
        className="absolute left-1 top-3 h-2 w-2 rounded-full bg-brand-blue/70"
      />
      <motion.span
        custom={0.25}
        variants={sparkleVariants}
        initial="initial"
        animate="animate"
        className="absolute right-2 top-1 h-2.5 w-2.5 rounded-full bg-bright-green"
      />
      <motion.span
        custom={0.2}
        variants={sparkleVariants}
        initial="initial"
        animate="animate"
        className="absolute bottom-6 left-0 h-1.5 w-1.5 rounded-full bg-brand-blue/50"
      />

      <div className="absolute inset-x-4 top-1 h-[58px] rounded-[14px] border border-border-grey/60 bg-gradient-to-br from-white via-white to-bg-light-blue shadow-[0_8px_20px_rgba(17,15,42,0.06)]">
        <div className="absolute left-3 top-3 h-2 w-8 rounded-full bg-bright-green/70" />
        <div className="absolute left-3 top-7 h-1.5 w-12 rounded-full bg-light-grey" />
        <div className="absolute left-3 top-10 h-1.5 w-9 rounded-full bg-light-grey/80" />
      </div>

      <motion.div
        className="absolute bottom-0 left-1/2 flex h-[54px] w-[54px] -translate-x-1/2 items-center justify-center rounded-full bg-bright-green shadow-[0_10px_28px_rgba(193,251,105,0.55)] ring-[5px] ring-white"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.12, duration: 0.4, ease: "easeOut" }}
      >
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
          <path
            d="M5 13l4 4L19 7"
            stroke="#0F1011"
            strokeWidth="2.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </motion.div>
    </motion.div>
  );
}
